import React from "react";

import { accordionData } from "../utility/accordianData";

const ResourceIndex = () => {
  return (
    <div className="my-8 max-w-5xl mx-auto">
      <h2 className="text-3xl font-bold mb-6 text-center">🔍 Explore Topics</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {accordionData.map((item, index) => (
          <div
            key={index}
            className="bg-[#f5fcff] rounded-xl shadow-md p-6 hover:shadow-xl transition-shadow duration-300 mx-2 border-l-2 border-[#ef8e38]"
          >
            <h3 className="text-xl font-semibold mb-2 text-[#ef8e38]">
              {item.header}
            </h3>
            <p className="text-sm text-gray-700 mb-4 line-clamp-3">
              {item.description}
            </p>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-indigo-500 hover:text-[#ef8e38] font-medium"
            >
              Read more ↗
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResourceIndex;
